// extracted by mini-css-extract-plugin
export default {"container":"UnderConstruction_container__LtcHD","intro":"UnderConstruction_intro__5nP4m"};